import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GreetingComponent } from './greeting.component';
import { GreetingService } from './greeting.service';
 
@NgModule({
  declarations: [
    GreetingComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [GreetingComponent], // Export the component so it can be used elsewhere
  providers: [GreetingService] // Provide the service
})
export class GreetingModule { }
 